export const soccerPositions = [
  'Goalkeeper',
  'Right Fullback',
  'Left Fullback',
  'Center Back',
  'Defending/Holding Midfielder',
  'Right Midfielder/Winger',
  'Central/Box-to-Box Midfielder',
  'Striker',
  'Attacking Midfielder/Playmaker',
  'Left Midfielder/Wingers',
];
export const TrackAndFieldPositions = [
  'Long Jump',
  'Triple Jump',
  'High Jump',
  'Pole Vault',
  'Shot Put',
  'Discus',
  'Javelin',
  'Hammer Throw',
  'Sprints',
  'Middle Distance',
  'Long Distance',
  'Hurdles',
  'Relays',
  'Decathlon',
  'Heptathlon',
];

export const basketballPositions = [
  'Small Forward',
  'Power Forward',
  'Center',
  'Shooting Guard',
  'Point Guard',
];

export const years = [2027, 2028, 2029, 2030];

export const iceHockeyPositions = [
  'Center',
  'Left Wing',
  'Right Wing',
  'Left Defense',
  'Right Defense',
  'Goaltender',
];

export const waterPoloPositions = [
  'Goalkeeper',
  'Attacker/Driver',
  'Center',
  'Center Defender',
  'Wing',
  'Utility',
];

export const sports = [
  'Volleyball',
  'Beach Volleyball',
  'Soccer',
  'Swimming',
  'Tennis',
  'Basketball',
  'Track & Field',
  'Ice Hockey',
  'Water Polo',
];

export const genders = ['Female', 'Male'];

export const voleyballPositions = ['OH', 'RS', 'Libero', 'Setter', 'DS', 'MH'];

export const beachVolleyballPositions = ['Block', 'Defense', 'Block/Defense'];

export const filters = {
  gender: [...genders],
  years: ['Filter all', ...years],
  positions: {
    volleyball: ['Filter all', ...voleyballPositions],
    beachVolleyball: ['Filter all', ...beachVolleyballPositions],
    soccer: ['Filter all', ...soccerPositions],
    basketball: ['Filter all', ...basketballPositions],
    iceHockey: ['Filter all', ...iceHockeyPositions],
    waterPolo: ['Filter all', ...waterPoloPositions],
  },
  sports: [...sports],
};

export default filters;
